// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"5997cbf0e46bf256025d","678":"f5dabda4d525dac33f88"}[chunkId] + ".js";
};